module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Right_16"],"polygon":[{"$":{"points":"5.68 14.24 4.32 12.76 9.52 8 4.32 3.24 5.68 1.76 12.48 8 5.68 14.24","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Right_16.svg
// module id = CVRd
// module chunks = 1